import { Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import {
  COMPANY_BILLING_REQUEST,
  COMPANY_BILLING_SUCCESSFUL,
  COMPANY_BILLING_FAILURE,
  COMPANY_BILLING_SAVE,
} from 'action-creators/companyBilling';
import { Company } from 'models/company';

import { RESET } from '../action-creators/generic';

export interface CompanyBillingState {
  company: Company | null;
  isLoading: boolean;
  error: string | null;
  saved: boolean;
}

const initialState: CompanyBillingState = {
  company: null,
  isLoading: false,
  error: null,
  saved: false,
};

const reducer: Reducer<CompanyBillingState> = (state = initialState, action) => {
  switch (action.type) {
    case COMPANY_BILLING_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case COMPANY_BILLING_SUCCESSFUL: {
      return {
        ...state,
        company: action.payload.company,
        isLoading: false,
      };
    }
    case COMPANY_BILLING_FAILURE: {
      return {
        ...state,
        company: null,
        isLoading: false,
        error: action.payload,
      };
    }
    case COMPANY_BILLING_SAVE: {
      return {
        ...state,
        company: initialState.company,
        saved: true,
      };
    }
    case RESET:
      return initialState;
    default:
      return state;
  }
};

const persistConfig = {
  storage,
  version: 1,
  key: 'companyBilling',
  blacklist: ['isLoading', 'error', 'saved'],
};

export default persistReducer(persistConfig, reducer);
